export const appToastKeyConst = 'AppToastKey';
